import React from 'react';
import {
  Edit,
  TextInput,
  BooleanInput,
  DateInput,
  SelectInput,
  ReferenceInput,
  TabbedForm,
  FormTab,
  required,
} from 'react-admin';
import { Grid } from '@mui/material';

const experienceRadiusChoices = [
  { id: 'LOCAL', name: 'Local' },
  { id: 'REGIONAL', name: 'Regional' },
  { id: 'LONG_HAUL', name: 'Long Haul' },
];

export const DriverEdit = () => (
  <Edit>
    <TabbedForm>
      <FormTab label="Basic Info">
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <ReferenceInput source="userId" reference="users">
              <SelectInput optionText="name" validate={required()} fullWidth />
            </ReferenceInput>
          </Grid>
          <Grid item xs={12} md={6}>
            <TextInput source="profileState" fullWidth />
          </Grid>
        </Grid>
      </FormTab>

      <FormTab label="Experience">
        <Grid container spacing={2}>
          <Grid item xs={12} md={4}>
            <BooleanInput source="hasCanadaExperience" />
            <TextInput source="canadaExperience" multiline rows={3} fullWidth />
          </Grid>
          <Grid item xs={12} md={4}>
            <BooleanInput source="hasUsaExperience" />
            <TextInput source="usaExperience" multiline rows={3} fullWidth />
          </Grid>
          <Grid item xs={12} md={4}>
            <BooleanInput source="hasInternationalExperience" />
            <TextInput source="internationalExperience" multiline rows={3} fullWidth />
          </Grid>
          <Grid item xs={12}>
            <SelectInput source="experienceRadius" choices={experienceRadiusChoices} fullWidth />
          </Grid>
        </Grid>
      </FormTab>

      <FormTab label="Safety">
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <BooleanInput source="hasRecentAccident" />
            <TextInput source="recentAccidentDescription" multiline rows={3} fullWidth />
          </Grid>
          <Grid item xs={12} md={6}>
            <BooleanInput source="hasRecentTicket" />
            <TextInput source="recentTicketDescription" multiline rows={3} fullWidth />
          </Grid>
          <Grid item xs={12}>
            <BooleanInput source="drugAlcohol3Year" label="Drug/Alcohol Issues (3 years)" />
          </Grid>
        </Grid>
      </FormTab>

      <FormTab label="Citizenship & Work Auth">
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <BooleanInput source="canadianCitizen" />
            <BooleanInput source="canadaLiveAndWork" />
            <BooleanInput source="canEnterUsa" />
            <BooleanInput source="usaDenied" />
          </Grid>
        </Grid>
      </FormTab>

      <FormTab label="Travel Documents">
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <BooleanInput source="hasValidPassport" />
            <TextInput source="passportCountryOrigin" fullWidth />
            <DateInput source="passportExpiry" fullWidth />
          </Grid>
          <Grid item xs={12} md={6}>
            <BooleanInput source="hasFastPass" />
            <TextInput source="fastPassNumber" fullWidth />
            <BooleanInput source="hasUsDotNumber" />
            <TextInput source="usDotNumber" fullWidth />
          </Grid>
        </Grid>
      </FormTab>
    </TabbedForm>
  </Edit>
);
